import { PlotReportFactElement, PlotReportFactLabelNameEnum } from '@/api/rest/resources/types/fact';
import { DonutChartData } from '@/components/Charts/DonutChart';
import { isNullish } from '@/utils/booleans';
import { getHexFromString } from '@/utils/getHexFromString';

export const getClassNameValuesFromFacts = ({
  facts,
}: {
  facts: PlotReportFactElement<number | null>[] | undefined;
}): string[] => {
  if (!facts) {
    return [];
  }

  return facts.flatMap((f) => {
    if (!f.labels || isNullish(f.value)) {
      return [];
    }

    const classNameLabel = f.labels.find((label) => label.name === PlotReportFactLabelNameEnum.class_name);
    if (typeof classNameLabel?.value !== 'string') {
      return [];
    }

    return classNameLabel.value;
  });
};

export const getGraphDataFromGraphFacts = (
  facts: PlotReportFactElement<number | null>[] | undefined,
  colors?: { class_value: string; color: string; text: string; gray_index: number }[],
): DonutChartData[] => {
  if (!facts) {
    return [];
  }

  return facts.flatMap((f) => {
    if (!f.labels || isNullish(f.value)) {
      return [];
    }
    const classNameLabel = f.labels.find((label) => label.name === PlotReportFactLabelNameEnum.class_name);

    if (typeof classNameLabel?.value !== 'string') {
      return [];
    }

    const classNameColor =
      colors?.find((color) => color.text === (classNameLabel.value as string))?.color ??
      getHexFromString(classNameLabel.value);

    return {
      name: classNameLabel.value,
      value: f.value as number,
      color: classNameColor,
      unit: f.unit,
    };
  });
};
